import { Button, Col, Descriptions, Modal, Row, Typography } from 'antd';
import { CopyOutlined, CreditCardOutlined } from '@ant-design/icons';
import { useState } from 'react';
import { useCopyToClipboard } from 'hooks/useCopyToClipboard';
import { useAppSelector } from 'redux/store';
import { selectUserProfile } from 'components/Account/AccountProfileTab/slice';

const { Text } = Typography;

export default function Recharge() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [, copy] = useCopyToClipboard();
  const userProfile = useAppSelector(selectUserProfile);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const bankingMessage = userProfile.banking_message || (localStorage.getItem('banking_message') as string) || '';
  const vietqrBankId = userProfile.vietqr_bank_id || (localStorage.getItem('vietqr_bank_id') as string) || '';
  const bankAccNo = userProfile.bank_acc_no || (localStorage.getItem('bank_acc_no') as string) || '';
  const bankName = userProfile.bank_name || (localStorage.getItem('bank_name') as string) || '';
  const bankAccName = userProfile.bank_acc_name || (localStorage.getItem('bank_acc_name') as string) || '';
  const defaultTransferNotice =
    'Vui lòng chuyển khoản tối thiếu 50.000 VNĐ (năm mươi nghìn Việt Nam Đồng) để hệ thống có thể xử lý.';
  const transferNotice =
    userProfile.transfer_notice && userProfile.transfer_notice.trim() !== ''
      ? userProfile.transfer_notice
      : defaultTransferNotice;

  const copyMoneyTransferContent = () => {
    copy(bankingMessage);
  };

  return (
    <>
      <Button
        type="primary"
        size="large"
        icon={<CreditCardOutlined />}
        className="bg-[#f5222d] text-sm"
        onClick={showModal}
      >
        Nạp tiền
      </Button>

      <Modal
        title="Nạp tiền vào tài khoản"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        width={800}
      >
        <Row gutter={[16, 16]} justify="center">
          <Col xs={24} sm={24} md={24} lg={8} xl={8}>
            <img
              src={`https://img.vietqr.io/image/${vietqrBankId}-${bankAccNo}-KvJmf8.jpg?addInfo=${bankingMessage}`}
              width={300}
              height={300}
              className="mx-auto"
              alt="img"
            />
          </Col>
          <Col xs={24} sm={24} md={24} lg={16} xl={16}>
            <Descriptions title="Chuyển khoản ngân hàng" layout="vertical">
              <Descriptions.Item label="Tên ngân hàng">{bankName}</Descriptions.Item>
              <Descriptions.Item label="Chủ tài khoản">{bankAccName}</Descriptions.Item>
              <Descriptions.Item label="Số tài khoản">
                {bankAccNo}
                <CopyOutlined
                  className="ml-2 inline-block"
                  style={{ color: '#007bfc' }}
                  onClick={() => {
                    copy(bankAccNo);
                  }}
                />
              </Descriptions.Item>
              <Descriptions.Item label="Nội dung chuyển khoản">
                {bankingMessage}
                <CopyOutlined
                  className="ml-2 inline-block"
                  style={{ color: '#007bfc' }}
                  onClick={copyMoneyTransferContent}
                />
              </Descriptions.Item>
              <Descriptions.Item label="Lưu ý">
                <Text type="danger" style={{ whiteSpace: 'pre-wrap' }}>
                  {transferNotice}
                </Text>
              </Descriptions.Item>
            </Descriptions>
          </Col>
        </Row>
      </Modal>
    </>
  );
}
